<!-- CirclePlusIcon.vue -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :class="classes"
  >
    <!-- Main circular container -->
    <circle
      cx="12" cy="12" r="9"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      opacity="0.9"
    />

    <!-- Simple plus sign -->
    <path
      d="M12 8v8M8 12h8"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CirclePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    },
    classes: {
      type: [String, Object, Array],
      default: ''
    }
  }
}
</script>
